import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';


const SosMaps = () => {
    const { latitude, longitude } = useParams();


    useEffect(() => {
        const device = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(device)) {
            window.location.href = `https://www.google.com/maps?q=${latitude},${longitude}`
        } else if (/iPad|iPhone|iPod/.test(device) && !window.MSStream) {
            window.location.href = `http://maps.apple.com/?ll=${latitude},${longitude}`
        } else {
            window.location.href = `https://www.google.com/maps?q=${latitude},${longitude}`;
        }
    }, [])

    return (
        <div>Redirecting...</div>
    )

}
export default SosMaps;